import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { LuTypeaheadOptions, LuTypeaheadUrlOptions } from 'lu-typeahead';

@Component({
	templateUrl: './lu-typeahead-formly.component.html'
})
export class LuTypeaheadFormlyComponent extends FieldType implements OnInit {
	typeaheadOptions: LuTypeaheadOptions;
	urlOptions: LuTypeaheadUrlOptions;
	initialItems: any;
	/**
	 * Expose way to set internal selection
	 * Whole objects instead of single prop (value of selectAs)
	 */
	internalSelection: any;

	ngOnInit(): void {
		if (this.to.luAdminTypeaheadOptions) {
			this.to.luAdminTypeaheadOptions.id = this.field.id;
		}
		this.typeaheadOptions = this.to.luAdminTypeaheadOptions;
		this.urlOptions = this.to.luAdminTypeaheadRouteParams;
		this.initialItems = this.to.luInitialItems;
		// Set internal selected state
		this.internalSelection = this.to.internalSelection;
	}

	change($event): void {
		if (!!this.to && !!this.to.change) {
			this.to.change($event, this.field.id);
		}
	}

	/**
	 * Emits data on typeahead internal selection variable change
	 * Needed to get whole selection object instead of only single prop saved in model
	 */
	internalSelectionChange($event: any[]): void {
		if (!!this.to && !!this.to.internalSelectionChange) {
			this.to.internalSelectionChange.next($event);
		}
	}

	/**
	 * Handles the state change of the dropdown and emits the new state
	 * through the `dropdownStateChange$` observable.
	 *
	 * @param event - A boolean indicating the new state of the dropdown.
	 *                `true` if the dropdown is open, `false` if it is closed.
	 */
	dropdownStateChange(event: boolean): void {
		this.to.dropdownStateChange$.next(event);
	}

	typeaheadReady($event): void {
		if (!!this.to && !!this.to.luTypeaheadReady) {
			this.to.luTypeaheadReady($event, this.field.id);
		}
	}
}
